module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark-eed232062b48b4c0b847fcea44bb3ea5.png";